// extracted by mini-css-extract-plugin
export default {"OrderTypes":"NewOrder_OrderTypes__8CnES","OrderButton":"NewOrder_OrderButton__zCXlQ","BookingModalHeading":"NewOrder_BookingModalHeading__aomA4"};